// Temporary file to support material-ui/styles@alpha
// https://material-ui.com/css-in-js/basics/

import install from '@material-ui/styles/install';

install();
